export const environment = {
    production: false,
	name: 'test',
    api:'https://test-api.lmsleads.com/',
    defaultauth: 'firebase',
    firebaseConfig: {
      apiKey: "AIzaSyC97mpFWAzru_N5T-t9RPeLxs9mnDcEyEA",
      authDomain: "lms-leads.firebaseapp.com",
      projectId: "lms-leads",
      storageBucket: "lms-leads.appspot.com",
      messagingSenderId: "583949757063",
      appId: "1:583949757063:web:4ddf556141003f9d13e622"
    }
  };

